import { Skeleton } from '@mui/material'
import { Card, LoadingTable } from 'components/core-v2'

import { COLUMN_DEFS } from './columns'

export const Loading = () => (
  <Card.Wrapper>
    <Card.Header>
      <Skeleton height="15px" variant="rectangular" width="160px" />
    </Card.Header>
    <LoadingTable agGridProps={{ columnDefs: COLUMN_DEFS, headerHeight: 60 }} height="400px" />
  </Card.Wrapper>
)
